// mission-projection-io.ts
//
// Tách khỏi mission-store.ts (giữ mỗi file ≤200 dòng): đọc/replay/ghi PROJECTION.
//
// Projection là CACHE dựng lại được, journal mới là sự thật. Vì vậy:
//   • thiếu file / JSON hỏng ⇒ trả undefined để caller rebuild từ journal (không throw);
//   • nhưng projection ĐI TRƯỚC journal thì KHÔNG phải cache cũ — đó là bằng chứng mất
//     dữ liệu, và việc phân loại đó nằm ở mission-store (nơi có đủ ngữ cảnh).

import { promises as fs } from "node:fs";
import { type DurableFsOps, writeFileDurable } from "./durable-file-writer.js";
import type { JournalRecord } from "./journal-scan-report.js";
import {
  emptyMissionState,
  type MissionDelta,
  type MissionState,
  reduceMission,
} from "./mission-state-reducer.js";

/** Áp các record có `seq >= fromSeq` lên `base`. Thuần, không I/O. */
export function replayRecords(
  base: MissionState,
  records: JournalRecord[],
  fromSeq: number,
): MissionState {
  let state = base;
  for (const record of records) {
    if (record.seq < fromSeq) continue;
    state = reduceMission(state, record.delta as MissionDelta, record.seq);
  }
  return state;
}

/** Đọc projection. Thiếu/hỏng ⇒ undefined (rebuild từ journal), KHÔNG throw. */
export async function readProjection(path: string): Promise<MissionState | undefined> {
  try {
    const parsed = JSON.parse(await fs.readFile(path, "utf8")) as Partial<MissionState>;
    if (typeof parsed.last_event_seq !== "number") return undefined;
    return { ...emptyMissionState(), ...parsed } as MissionState;
  } catch {
    return undefined;
  }
}

/** Ghi projection BỀN (tmp → fsync → rename → fsync dir). */
export async function writeProjection(
  path: string,
  state: MissionState,
  ops: DurableFsOps,
): Promise<void> {
  await writeFileDurable(path, Buffer.from(`${JSON.stringify(state, null, 2)}\n`, "utf8"), { ops });
}
